import { render, staticRenderFns } from "./Parameters.vue?vue&type=template&id=b8281c2a&scoped=true"
import script from "./Parameters.vue?vue&type=script&lang=js"
export * from "./Parameters.vue?vue&type=script&lang=js"
import style0 from "./Parameters.vue?vue&type=style&index=0&id=b8281c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8281c2a",
  null
  
)

export default component.exports